<template>
  <a class="plugin-wrapper p-9 d-flex" :class="'flex-' + position" target="_blank" href="/plugin/">
    <div class="mr-10 cursor-pointer">
      <img width="72px" alt="" src="/dist/assets/front_white/img/landing_plugin/plugin__settings.svg" />
      <div v-if="position==='row'">
        <img width="11px" alt="" src="/dist/assets/front_white/img/landing_plugin/rating-full.svg" />
        <img width="11px" alt="" src="/dist/assets/front_white/img/landing_plugin/rating-full.svg" />
        <img width="11px" alt="" src="/dist/assets/front_white/img/landing_plugin/rating-full.svg" />
        <img width="11px" alt="" src="/dist/assets/front_white/img/landing_plugin/rating-full.svg" />
        <img width="11px" alt="" src="/dist/assets/front_white/img/landing_plugin/rating-half.svg" />
      </div>
    </div>
    <div class="plugin-desc">
      <div class="plugin-desc__title cursor-pointer">Мастер спецификаций</div>

      <div v-if="position==='column'" class="mt-3 mb-6 cursor-pointer">
        <img width="11px" alt="" src="/dist/assets/front_white/img/landing_plugin/rating-full.svg" />
        <img width="11px" alt="" src="/dist/assets/front_white/img/landing_plugin/rating-full.svg" />
        <img width="11px" alt="" src="/dist/assets/front_white/img/landing_plugin/rating-full.svg" />
        <img width="11px" alt="" src="/dist/assets/front_white/img/landing_plugin/rating-full.svg" />
        <img width="11px" alt="" src="/dist/assets/front_white/img/landing_plugin/rating-half.svg" />
      </div>

      <div class="plugin-desc__text" @click.prevent.stop>Решает проблему  рутинного поиска по сайтам и каталогам с неизвестной актуальностью инженерных данных.</div>
      <div class="plugin-desc__link cursor-pointer">Узнать подробнее <i class="icon-path"></i></div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    /**
     * row, column
     */
    position: {
      type: String,
      default: "row"
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/color";

.cursor-pointer {
  cursor: pointer;
}

.plugin-wrapper {
  border-radius: 5px;
  background-color: $white-color;
  cursor: auto;
}

.plugin-wrapper.flex-row {
  box-shadow: 0 20px 40px 0 $white-color-100;
  border: solid 0.5px $white-color-500;
}

.plugin-desc {
  .plugin-desc__title {
    font-size: 14px;
    font-weight: bold;
    line-height: 1.44;
    margin-top: 8px;
  }
  .plugin-desc__text {
    padding: 2px 0 8px;
    font-size: 14px;
    line-height: 1.57;
    letter-spacing: 0.2px;
  }
  .plugin-desc__link {
    font-size: 12px;
    line-height: 1.83;
    letter-spacing: 0.5px;
    color: $primary-color;
    
    .icon-path {
      font-size: 9px;

      &::before {
        color: $primary-color;
      }
    }
  }
}
</style>
